import { Box, Divider, FormControl, Grid, Typography } from "@mui/material";
import { Control, UseFormGetValues, UseFormReset, UseFormSetValue, useWatch } from "react-hook-form";
import { useEffect, useState } from "react";

import colors from "../../styles/colors/colors";
import fontWeight from "../../styles/mui/fontWeight";
import { FormInputText } from "./FormInputText";
import { FormInputDropdown } from "./FormInputDropdown";
import { PhoneFaxExtInput } from "./PhoneFaxExtInput";
import { rules } from "../../utils/validations/Validations";
import { RelationshipMaster } from "../../models/MemberDetails";
import {
  DividerStyle,
  EmergencyContactContainer,
  EmergencyContactHeading,
} from "./styles/style";
import { getList, getValue, isEmptyValue } from "../../utils";
import { TabData } from "../../models/TabSessionStorage";

export interface PropsFromState {
  control: Control<any, any>;
  relationData: RelationshipMaster[];
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<TabData>;
  reset: UseFormReset<TabData>;
}
type AllProps = PropsFromState;

const EmergencyContact: React.FC<any> = ({
  control,
  relationData,
  setValue,
  getValues,
  reset,
}: AllProps) => {
  const [helperRequired, setHelperRequired] = useState(false);
  const emergencyContactFields = useWatch({
    name: "emergencyContact",
    control,
  });
  useEffect(() => {
    if (!isEmptyValue(emergencyContactFields ? emergencyContactFields : {})) {
      setHelperRequired(true);
    } else {
      setHelperRequired(false);
    }
  }, [emergencyContactFields]);

  useEffect(() => {
    setTimeout(() => {
      if (!helperRequired) {
        reset(
          {
            ...getValues()
          },
          { keepErrors: false }
        );
      }
    }, 10);
  }, [helperRequired]);

  const handleRelation = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedRelation = relationData.filter((item: RelationshipMaster) => {
      return item.relationId === Number(e.target.value);
    })[0];
    setValue(
      "emergencyContact.relationshipName",
      getValue(selectedRelation, "relationshipName")
    );
    setValue("emergencyContact.relationId", e.target.value);
  };

  const ruleOverrideContactName = (required: boolean) => {
    rules.emergencyContactName.required.value = required;
    return rules.emergencyContactName;
  }

  const ruleOverrideRelation = (required: boolean) => {
    rules.relation.required.value = required;
    return rules.relation;
  }

  const ruleOverridePhone = (required: boolean) => {
    rules.emergencyContactPhone.required.value = required;
    return rules.emergencyContactPhone;
  }

  return (
    <Grid container sx={EmergencyContactContainer}>
      <Grid size={12} sx={EmergencyContactHeading}>
        <Box>
          <Typography
            variant="h5"
            fontWeight={fontWeight.Weight[4]}
            color={colors.black[2]}
          >
            Emergency Contact Details
          </Typography>
        </Box>
        <Box>
          <Divider orientation="vertical" flexItem sx={DividerStyle} />
        </Box>
        <Box>
          <Typography
            variant="body1"
            fontWeight={fontWeight.Weight[2]}
            color={colors.fonts[2]}
            pt={"0.2rem"}
          >
            If you have information of an emergency contact for this member
            please fill in the fields below.
          </Typography>
        </Box>
      </Grid>
      <Grid size={12}>
        <Grid container>
          <Grid size={3} pr={"3rem"}>
            <FormControl variant="standard" fullWidth>
              <FormInputText
                name={`emergencyContact.contactName`}
                control={control}
                textLength={30}
                helper={ruleOverrideContactName(helperRequired)}
                label="Contact Name:"
              />
            </FormControl>
          </Grid>
          <Grid size={3} pr={"3rem"}>
            <FormControl variant="standard" fullWidth>
              <FormInputDropdown
                control={control}
                name={`emergencyContact.relationId`}
                list={getList(relationData, {
                  label: "relationshipName",
                  value: "relationId",
                })}
                label="Relationship:"
                onChangeHandler={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleRelation(e)
                }
                helper={ruleOverrideRelation(helperRequired)}
                allowEmptySelection={true}
              />
            </FormControl>
          </Grid>
          <Grid size={3} pr={"3rem"}>
            <PhoneFaxExtInput
              control={control}
              phoneFaxName={`emergencyContact.phoneNo`}
              label="Contact Number:"
              rules={ruleOverridePhone(helperRequired)}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmergencyContact;
